import { DateSlot } from 'src/app/model/dateslot.model';
import { LessonType } from './lesson-type.model';
import { SportType } from './sport-type.model';
import { InstructorStatus } from './instructor-status.model';
import { User } from './user.model';

export class Instructor {

  constructor(
    public user:User,
    public dateSlotsAvailable: DateSlot[],
    public status: InstructorStatus,
    public lessonTypes: LessonType[],
    public sportTypes: SportType[]) {
  }
}


